// extracted by mini-css-extract-plugin
module.exports = {"feedbackContainer":"feedback_feedbackContainer__2vi4H"};